import { Flex } from '@abyss/web/ui/Flex';
import { Text } from '@abyss/web/ui/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { capitalizeAllFirstCharacters } from '../../../../utils/providerNames.utils';
import { NetworkAffiliationLabels } from '../../../Constants';
import {
  networkAffiliationCardContainer,
  networkAffiliationCardContentContainer,
  networkAffiliationCardEnrollmentLabelStyle,
  networkAffiliationCardEnrollmentValueStyle,
  networkAffiliationCardNameContainer,
  networkAffiliationCardNameStyle,
  networkAffiliationCardTextStyle,
} from './NetworkAffiliations.style';

export interface NetworkAffiliation {
  networkAffiliationId: string;
  networkAffiliationName: string;
  acceptingNewPatients: boolean;
  pcpId?: string;
  specialities?: Array<{ id: string; value: string }>;
  medicalgrpaffilIdName?: string;
  pcpIndicator?: boolean;
  networkAffiliationTypeCode?: string;
}

interface NetworkAffiliationsCardProps {
  affiliation: NetworkAffiliation;
  testId?: string;
  onClick?: () => void;
}

export const NetworkAffiliationsCard: React.FC<
  NetworkAffiliationsCardProps
> = ({ affiliation, testId = 'network-affiliation-card', onClick }) => {
  const { t } = useTranslation();

  const status = affiliation.acceptingNewPatients
    ? t(NetworkAffiliationLabels.ACCEPTING_NEW_PATIENTS)
    : t(NetworkAffiliationLabels.NOT_ACCEPTING_NEW_PATIENTS);

  const enrollmentId = affiliation.pcpId || t('Not available / unknown');
  const affiliationName = capitalizeAllFirstCharacters(
    affiliation.networkAffiliationName?.toLowerCase() ||
      t('Not available / unknown')
  );

  return (
    <Flex
      css={networkAffiliationCardContainer}
      data-auto-testid={testId}
      data-testid={testId}
      direction="column"
    >
      <Flex
        css={networkAffiliationCardNameContainer}
        direction="column"
        onClick={onClick}
      >
        <Text css={networkAffiliationCardNameStyle} fontWeight="$semibold">
          <span title={affiliationName}>{affiliationName}</span>
        </Text>
      </Flex>
      <div
        style={{
          width: '100%',
          height: '0px',
          borderBottom: '1px solid #CBCCCD',
        }}
      />
      <Flex css={networkAffiliationCardContentContainer} direction="column">
        <Text css={networkAffiliationCardTextStyle} fontWeight="$semibold">
          {status}
        </Text>
        <Flex
          css={{
            gap: '4px',
            alignItems: 'baseline',
            overflow: 'hidden',
            flexWrap: 'nowrap',
            minWidth: 0,
          }}
        >
          <Text
            css={networkAffiliationCardEnrollmentLabelStyle}
            fontWeight="$semibold"
          >
            {t(NetworkAffiliationLabels.ENROLLMENT_ID)}
          </Text>
          <Text
            css={networkAffiliationCardEnrollmentValueStyle}
            fontWeight="$normal"
          >
            <span title={enrollmentId}>{enrollmentId}</span>
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
